import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_uu21e90o: FaireBrandEntity = {
  token: "b_uu21e90o",
  type: "brand",
  name: "Nicole Marie Paperie",
  avatarUrl:
    "https://cdn.faire.com/fastly/dbea4c265bbeba260fbb14488958938951d0a7302010bc61b14eb0cd3baee300.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/85bec143f5cbc36c9e628802166d60473d99ffaa972c3c0282afd1f8d3db6609.png",
  logoUrl:
    "https://cdn.faire.com/fastly/dbea4c265bbeba260fbb14488958938951d0a7302010bc61b14eb0cd3baee300.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/85bec143f5cbc36c9e628802166d60473d99ffaa972c3c0282afd1f8d3db6609.png",
  location: "New York City, NY, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 30,
  isInsider: true,
  description:
    "Check out my interview with Vox! https://www.vox.com/even-better/362777/buy-black-business-owners-stationery-gifts\n\nWelcome to Nicole Marie Paperie! Crafted with tender loving care in NYC by designer and illustrator Nicole Alesi.\n\nSince 2013, Nicole Marie Paperie has been bringing vibrant and original designs to life on greeting cards, stationery, buttons, and stickers. Each product is printed on eco-friendly paper, proudly produced in the USA, and carefully hand-assembled. Whether for birthdays or just because, I am thrilled and grateful to contribute to your special moments.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:57.162Z",
    importedBy: "entity-db-cli",
  },
};
